/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import { ScrollAwareContext, ScrollAwareAppNavStep } from '../../components/ScrollAware';
import Page from '../../applicationFrame/Page';

import HealthEntryOccurrence from './HealthEntryOccurrence';
import HealthEntryOccurrenceList from './HealthEntryOccurrenceList';
import { HealthEntry } from '../../../models/HealthEntry';
import HealthEntryCategoryNames from '../../../constants/HealthEntryCategoryNames';

import RouteNames from '../../appAuthorized/RouteNames';
import { useNavigate } from '../../hooks/useNavigate';
import { useHealthEntryForActiveProfile } from '../../hooks/useHealthEntry';

interface Props {
  healthEntryId: number;
  healthEntryValueId: number;
  isNew: boolean;
}
const Occurence: React.FC<Props> = (props) => {
  const { healthEntryId, healthEntryValueId, isNew } = props;
  const [, heActions] = useHealthEntryForActiveProfile(healthEntryId);
  const healthEntry = heActions.instantiateHealthEntry();
  const category = healthEntry.category;

  switch (category) {
    case HealthEntryCategoryNames.missing:
      return null;
    case HealthEntryCategoryNames.lab:
    case HealthEntryCategoryNames.measurement:
    case HealthEntryCategoryNames.geneticResult:
      if (healthEntryValueId) {
        return (
          <HealthEntryOccurrence
            healthEntryId={healthEntryId}
            healthEntryValueId={healthEntryValueId}
            isHeaderDefaultExpanded={isNew}
            isNew={isNew}
          />
        );
      } else {
        return (
          <HealthEntryOccurrenceList
            healthEntryId={healthEntryId}
            isNew={isNew}
          />
        );
      }
    default:
      return (
        <HealthEntryOccurrence
          healthEntryId={healthEntryId}
          healthEntryValueId={healthEntryValueId}
          isHeaderDefaultExpanded={Boolean(healthEntryValueId) && isNew}
          isNew={isNew}
        />
      );
  }
};

const HealthEntryOccurrenceController = (props) => {
  const { location, match } = props;
  const queryParam = location.search;
  const healthEntryId = Number(match.params.healthEntryId);
  const healthEntryValueId = Number(match.params.valueId);
  const isNew = queryParam === '?mode=create';
  const [, navActions] = useNavigate();

  return (
    <Page>
      <ScrollAwareContext>
        <ScrollAwareAppNavStep
          done={() => {
            if (healthEntryValueId) {
              if (isNew) {
                navActions.goBack(RouteNames.healthEntry(healthEntryId));
              } else {
                navActions.goBack(RouteNames.healthEntry(healthEntryId), {}, [
                  {
                    pathname: RouteNames.myBackpackSelectionFiles(),
                  },
                  {
                    pathname: RouteNames.healthEntryValue(healthEntryId, healthEntryValueId),
                  },
                ]);
              }
            } else if (isNew) {
              navActions.goTo(RouteNames.myBackpack());
            } else {
              navActions.goBack(RouteNames.myBackpack());
            }
          }}
          color="white"
        />

        <Occurence
          healthEntryId={healthEntryId}
          healthEntryValueId={healthEntryValueId}
          isNew={isNew}
        />
      </ScrollAwareContext>
    </Page>
  );
};

export default HealthEntryOccurrenceController;
